import { useEffect, useState } from "react";
import { Redirect, useHistory } from "react-router-dom";
import MovementScreen from "../../components/movement-screen/movement-screen";
import AssessmentSettings from "../../models/interfaces/assessment-settings";
import { AssessmentUtils } from "../../utilities/assessments/assessment-utils";
import BaseCardLayout from "../../components/base-card-layout/base-card-layout";
import { useAuthState } from "../../utilities/contexts/auth-state-context";
import { AssessmentsUserMenu } from "../../components/assessments-user-menu/assessments-user-menu";
import { BackControllerProvider, useBackController } from "../../components/back-controller/back-controller";
import { NavigationDirectionProvider, useNavigationDirection } from "../../components/navigation-direction-context/navigation-direction-content";

const COMPONENT_CLASS = "p-movement-assessment";


// ---------- MovementInner ----------
// Without this order of rendering, the nvigation provider errors out.
const MovementInner: React.FC = () => {
    const history = useHistory();
    const [settings, setSettings] = useState<AssessmentSettings>({
        completedGroupIds: [],
        currentSlideIndex: 0,
        currentGroupIndex: 0,
        questionResponses: [],
        slideGroups: [],
    });
    const { setDirection } = useNavigationDirection();
    const { invoke } = useBackController();


    useEffect(() => {
        document.body.classList.add("-nav-hidden");
        return () => document.body.classList.remove("-nav-hidden");
    }, []);

    const onBackButtonClick = () => {
        // 1) Offer back to deepest child (MultiplePainScale etc.)
        if (invoke()) return;

        // 2) Mark navigation direction as backward
        setDirection("backward");

        // 3) Run normal wizard/back logic
        if (AssessmentUtils.isFirstSlideAndFirstGroup(settings)) {
            history.goBack();
            return;
        }

        setSettings(AssessmentUtils.moveToPreviousPage(settings));
    };


    return (
        <div className={COMPONENT_CLASS}>
            <div className={`user-menu hide-on-mobile`} style={{}}>
                <AssessmentsUserMenu profileImage={false} />
            </div>
            <BaseCardLayout>
                <MovementScreen
                    screenSettings={settings}
                    setScreenSettings={setSettings}
                    settingsOnBack={onBackButtonClick}
                />
            </BaseCardLayout>
        </div>
    );
};

// ---------- Root Movement ----------
const Movement: React.FC = () => {
    const { state } = useAuthState();

    if (!state.authenticated) {
        return <Redirect to="/login" />;
    }

    if (state.user && state.user?.leadLinkId && state.user.organizationId === process.env.REACT_APP_LEAD_CAPTURE_ORG_ID) {
        return <Redirect to="/lc-assessment-results" />
    }
    return (
        <>
            <NavigationDirectionProvider>
                <BackControllerProvider>
                    <MovementInner />
                </BackControllerProvider>
            </NavigationDirectionProvider>
        </>
    );
};

export default Movement;
